import type { HelpArticle } from '../../../components/help/types';

export const analyticsArticles: HelpArticle[] = [
  {
    id: 'platform-analytics-overview',
    title: 'Platform Analytics',
    summary: 'Understanding platform-wide analytics and metrics.',
    category: 'analytics',
    order: 1,
    keywords: ['analytics', 'metrics', 'statistics', 'dashboard', 'reports'],
    content: `
# Platform Analytics

Monitor platform health and usage across all MDAs.

## Analytics Dashboard

### Overview Metrics
- Total active MDAs
- Total users (all MDAs)
- Total documents stored
- Storage utilization
- System uptime

### MDA Comparison
Compare activity across institutions:
- Document counts
- User activity
- Workflow completion rates
- Storage usage

### Usage Trends
Historical data visualization:
- Daily/weekly/monthly trends
- Growth patterns
- Peak usage times
- Seasonal variations

## Available Reports

### System Health
- Server performance
- Database statistics
- Error rates
- Response times

### User Activity
- Login frequency
- Active users
- Session duration
- Feature usage

### Storage Analytics
- Storage by MDA
- Document types distribution
- Growth projections
- Cleanup recommendations

## Exporting Data

Export analytics in multiple formats:
- PDF for presentations
- Excel for analysis
- CSV for data processing
- Scheduled email delivery

## Setting Up Alerts

Configure notifications for:
- Unusual activity spikes
- Storage thresholds
- Error rate increases
- Security events
    `,
  },
];
